import { getContentfulClient } from './client';
import { resolveAssetUrl, unwrapField, unwrapLinkField } from './utils';

const CONTENT_TYPE_OTHER_PROJECTS = 'otherProjects';

async function fetchAllOtherProjectsEntries(client) {
  const limit = 100;
  let skip = 0;
  const items = [];
  const assetsById = new Map();

  const include = 10;

  for (;;) {
    const response = await client.getEntries({
      content_type: CONTENT_TYPE_OTHER_PROJECTS,
      limit,
      skip,
      order: 'sys.createdAt',
      include,
    });

    items.push(...response.items);
    const includedAssets =
      response.includes?.Asset || response.includes?.asset || [];
    includedAssets.forEach((a) => {
      if (a?.sys?.id) {
        assetsById.set(a.sys.id, a);
      }
    });

    if (response.items.length < limit) {
      break;
    }
    skip += limit;
  }

  return { items, assetsById };
}

function normalizeLogoValue(logoField) {
  let v = unwrapLinkField(logoField);
  if (Array.isArray(v)) {
    v = v[0];
  }
  return v;
}

function mapOtherProjectEntry(entry, assetsById) {
  const f = entry.fields || {};

  return {
    id: entry.sys?.id,
    title: unwrapField(f.title) || '',
    description: unwrapField(f.description) || '',
    logoUrl: resolveAssetUrl(normalizeLogoValue(f.logo), assetsById),
  };
}

export async function fetchOtherProjectsPageData() {
  const client = getContentfulClient();
  if (!client) {
    throw new Error('Contentful is not configured');
  }

  const { items, assetsById } = await fetchAllOtherProjectsEntries(client);
  return items.map((e) => mapOtherProjectEntry(e, assetsById));
}

